/* @flow */
import React, { useContext } from 'react';
import classnames from 'classnames';

import { TileContext } from '../helpers/TileContext';
import { CREATOR_UNKNOWN } from '../constants';

// Styles
import styles from './styles.scss';

// Types
type TitleProps = {|
    creationDate?: string | null,
    creatorName?: string | null,
    disableLinks?: boolean,
    isArt?: boolean,
    pdpUrl: string,
    title: string,
    onClick?: () => void,
    titleOneLine: boolean,
    titleClassName?: string | null,
|};

function Title(props: TitleProps) {
    const { imageSize } = useContext(TileContext);
    const {
        isArt,
        creatorName,
        creationDate,
        disableLinks,
        pdpUrl,
        onClick,
        title,
        titleOneLine,
        titleClassName,
    } = props;

    const shouldShowCreatorName = !!creatorName && creatorName.toLowerCase() !== CREATOR_UNKNOWN;

    const titleEl = isArt ? (
        <h2 className={styles.title}>
            {shouldShowCreatorName && (
                <div className={styles.ellipsis} data-tn="portfolio-row-creator-name">
                    {creatorName}
                </div>
            )}
            <div
                className={classnames(styles.artOneLine, {
                    [styles.noCreator]: !shouldShowCreatorName,
                })}
            >
                <span
                    className={classnames(styles.ellipsis, titleClassName)}
                    data-tn="portfolio-row-product-name"
                >
                    {title}
                </span>
                {creationDate && `, ${creationDate}`}
            </div>
        </h2>
    ) : (
        <h2
            className={classnames(styles.title, titleClassName, {
                [styles.ellipsis]: titleOneLine,
            })}
            data-tn="portfolio-row-product-name"
        >
            {title}
        </h2>
    );

    if (disableLinks) {
        return <span className={classnames(styles.link, styles[imageSize])}>{titleEl}</span>;
    }

    return (
        <a
            className={classnames(styles.link, styles[imageSize])}
            data-tn="item-title-link"
            href={pdpUrl}
            onClick={onClick}
        >
            {titleEl}
        </a>
    );
}

Title.defaultProps = {
    disableLinks: false,
};

export default Title;
